module.exports = __webpack_public_path__ + "bn.384df9d992676edd14cd.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/bn.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/bn.svg
// module chunks = styles